import React from 'react';
import { Container, Row, Col, Card, Accordion } from 'react-bootstrap';

const AboutService = () => {
  return (
    <Container>
      <h1 className="mb-4">About QR Security Service</h1>
      
      <Row className="mb-5">
        <Col md={6}>
          <h2>What is QR Security?</h2>
          <p className="lead">
            QR Security is an innovative service that helps protect your personal belongings using custom QR codes.
          </p>
          <p>
            Our service allows you to create personalized QR codes that you can attach to your valuable items. 
            If your item is lost and found by someone, they can scan the QR code to see your custom message 
            and contact information (if you choose to share it).
          </p>
          <p>
            Unlike regular QR codes, our anti-fool technology ensures that your QR codes cannot be easily 
            duplicated or tampered with, providing an extra layer of security for your belongings.
          </p>
        </Col>
        <Col md={6}>
          <img 
            src="https://via.placeholder.com/600x400?text=QR+Security+Concept" 
            alt="QR Security Concept" 
            className="img-fluid rounded shadow"
          />
        </Col>
      </Row>
      
      <Card className="mb-5 bg-light">
        <Card.Body>
          <Row>
            <Col md={4} className="text-center mb-3 mb-md-0">
              <div className="display-3 mb-2">🔒</div>
              <h3>Secure</h3>
              <p>Our QR codes use advanced security features to prevent duplication.</p>
            </Col>
            <Col md={4} className="text-center mb-3 mb-md-0">
              <div className="display-3 mb-2">🔄</div>
              <h3>Simple</h3>
              <p>Easy to generate, print, and attach to your belongings.</p>
            </Col>
            <Col md={4} className="text-center">
              <div className="display-3 mb-2">👤</div>
              <h3>Private</h3>
              <p>You control what information is shared when your QR code is scanned.</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      
      <h2 className="mb-4">Frequently Asked Questions</h2>
      <Accordion className="mb-5">
        <Accordion.Item eventKey="0">
          <Accordion.Header>How does QR Security work?</Accordion.Header>
          <Accordion.Body>
            QR Security works by generating unique QR codes that contain your custom message and optional contact information. 
            You can print these QR codes and attach them to your personal belongings. If someone finds your lost item, 
            they can scan the QR code to see your message and potentially contact you to return the item.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>What makes these QR codes secure?</Accordion.Header>
          <Accordion.Body>
            Our QR codes include special security features that make them difficult to duplicate or tamper with. 
            Additionally, we don't store sensitive personal information in the QR code itself, and you have full control 
            over what information is shared when your code is scanned.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>What items can I use QR Security for?</Accordion.Header>
          <Accordion.Body>
            You can use QR Security for virtually any personal item that could potentially be lost and found, such as:
            <ul>
              <li>Electronics (laptops, phones, tablets)</li>
              <li>Personal accessories (wallets, keys, bags)</li>
              <li>Sports equipment</li>
              <li>Musical instruments</li>
              <li>And much more!</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>How do I attach the QR codes to my items?</Accordion.Header>
          <Accordion.Body>
            After generating your QR code, you can download and print it on adhesive paper or regular paper and laminate it. 
            We also offer premium weatherproof QR code stickers that are durable and can withstand various conditions.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      
      <Row className="mb-5">
        <Col>
          <Card className="bg-primary text-white">
            <Card.Body className="text-center p-5">
              <h2 className="mb-3">Ready to secure your belongings?</h2>
              <p className="lead mb-4">
                Join thousands of users who trust QR Security to protect their valuable items.
              </p>
              <a href="/register" className="btn btn-light btn-lg">Get Started Now</a>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutService;